import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import "./SideModal.css";

interface ISideModal {
    show: boolean;
    handleClose: any;
    body: any
    title: string
    footer?: any
}


export default function SideModal(props: ISideModal) {
    if (!props.show) return null;

    return (
        <>
            <div className="ds-drawer-overlay" onClick={props.handleClose} />
            <aside className="ds-drawer ds-scope" role="dialog" aria-modal="true">
                <div className="ds-drawer-header">
                    <span className="ds-drawer-title">{props.title}</span>
                    <button
                        type="button"
                        className="ds-icon-btn"
                        onClick={props.handleClose}
                        aria-label="Close"
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>

                <div className="ds-drawer-body">
                    {props.body}
                </div>

                {props.footer && (
                    <div className="ds-drawer-footer">
                        {props.footer}
                    </div>
                )}
            </aside>
        </>
    )
}
